import constant from "@/common/constant";

export default {
	saveDeviceInfo() {
		return Promise.resolve(
			this.store(
				constant.STORAGE_KEY.DEVICE_DATA,
				JSON.stringify(this.getDeviceData()),
			),
		);
	},
	getDeviceData() {
		return {
			deviceName: this.getDeviceOS() + " Device",
			deviceOs: this.getDeviceOS(),
			deviceType: this.onCheckMobileDevice(),
			deepLink: this.onCheckMobileDevice() === "Mobile Device",
			deviceOsVersion: "",
			deviceLocation: "",
			browserName: this.getBrowserFromUserAgent(navigator.userAgent),
			browserVersion: this.getBrowserVersionFromUserAgent(
				navigator.userAgent,
			),
		};
	},
	removeDeviceInfo() {
		this.remove(constant.STORAGE_KEY.DEVICE_DATA);
		return Promise.resolve(null);
	},

	getDeviceInfo() {
		let deviceDataStr = this.get(constant.STORAGE_KEY.DEVICE_DATA);
		return deviceDataStr ? JSON.parse(deviceDataStr) : null;
	},

	store(key, value) {
		value == null || value === undefined
			? localStorage.removeItem(key)
			: localStorage.setItem(key, value);
	},

	get(key) {
		return localStorage.getItem(key);
	},

	remove(key) {
		return localStorage.removeItem(key);
	},

	getDeviceOS() {
		const { userAgent } = navigator;
		let OS;
		if (userAgent.match(/Android/i)) {
			OS = "Android";
		} else if (userAgent.match(/iP(ad|hone|od)/i)) {
			OS = "iOS";
		} else if (userAgent.match(/Mac(intosh| OS X)/i)) {
			OS = "MacOS";
		} else if (userAgent.match(/Windows/i)) {
			OS = "Windows";
		} else if (userAgent.match(/Linux/i)) {
			OS = "Linux";
		}
		return OS;
	},

	onCheckMobileDevice() {
		const userAgent = this.getDeviceOS();
		return /Android|iOS/i.test(userAgent)
			? "Mobile Device"
			: "Desktop Device";
	},

	getBrowserFromUserAgent(userAgent) {
		if (userAgent.indexOf("Firefox") > -1) {
			return "Mozilla Firefox";
			// "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
		} else if (userAgent.indexOf("SamsungBrowser") > -1) {
			return "Samsung Internet";
			// "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
		} else if (
			userAgent.indexOf("Opera") > -1 ||
			userAgent.indexOf("OPR") > -1
		) {
			return "Opera";
			// "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
		} else if (userAgent.indexOf("Trident") > -1) {
			return "Microsoft Internet Explorer";
			// "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
		} else if (userAgent.indexOf("Edg") > -1) {
			return "Microsoft Edge";
			// "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
		} else if (userAgent.indexOf("Chrome") > -1) {
			return "Google Chrome or Chromium";
			// "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
		} else if (userAgent.indexOf("Safari") > -1) {
			return "Apple Safari";
			// "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
		} else {
			return "Unknown";
		}
	},

	getBrowserVersionFromUserAgent(userAgent) {
		if (userAgent.includes("Firefox/")) {
			return `Firefox v${userAgent.split("Firefox/")[1]}`;
		} else if (userAgent.includes("Edg/")) {
			return `Microsoft Edge v${userAgent.split("Edg/")[1]}`;
		} else if (userAgent.includes("Chrome/")) {
			return `Google Chrome v${userAgent.split("Chrome/")[1]}`;
		} else if (userAgent.includes("Safari/")) {
			return `Safari v${userAgent.split("Safari/")[1]}`;
		} else {
			return "Unknown";
		}
	},
};
